import JsonLd from 'lib/json-ld/JsonLd'

export default class AnswerJsonLd extends JsonLd {
  constructor (answer) {
    super('Answer')
    this.text = answer
  }

  static create ({ answer }) {
    return new AnswerJsonLd(answer)
  }
}
